import { render, staticRenderFns } from "./about.vue?vue&type=template&id=420b0c26&scoped=true"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"
import style0 from "./about.vue?vue&type=style&index=0&id=420b0c26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420b0c26",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SubNav: require('/app/components/SubNav.vue').default,Sticky: require('/app/components/Sticky.vue').default,AnimBottomToTop: require('/app/components/AnimBottomToTop.vue').default,Anchor: require('/app/components/Anchor.vue').default,SvgCarouselPrev: require('/app/components/svg/CarouselPrev.vue').default,SvgCarouselNext: require('/app/components/svg/CarouselNext.vue').default})
